@if (!isLoading()) {
  <div class="check-ins-pop-up">
    <button class="check-ins-pop-up__close" (click)="close()">
      <lib-icon iconName="utilityCloseIcon"></lib-icon>
    </button>
    <div class="check-ins-pop-up__header">
      <lib-icon iconName="checkInsIcon"></lib-icon>
      <span>{{ surveySelected() }}</span>
    </div>
    <div class="check-ins-pop-up__body">
      <div class="check-ins-pop-up__body__summary">
        <lib-check-ins-summary-survey-list [checkInsSummary]="checkInsSummary"
                                           [outsideSelectedSurvey]="surveySelected()"
                                           (onCheckInSelected)="onSurveyChange($event)"
        >
        </lib-check-ins-summary-survey-list>
      </div>
      <div class="check-ins-pop-up__body__content">
        @let s = surveyToShow();
        @if (s) {
          @for (k of surveyToShowFormatted(); track $index) {
            <div class="check-ins-pop-up__body__content__q">
              <div class="check-ins-pop-up__body__content__q__title">
                {{ k.key }}
              </div>
              <div class="check-ins-pop-up__body__content__q__value">
                @if (k.customValue) {
                  @if (!k.type) {
                    {{ k.customValue }}
                  } @else if (k.type === 'img') {
                    <a class="check-ins-pop-up__body__content__q__value__img"
                       target="_blank"
                       [href]="k.customValue"
                    >
                      <img [ngSrc]="k.customValue"
                           fill alt="Survey Image"
                           priority
                      >
                    </a>
                  }
                }
              </div>
            </div>
          }
        }
      </div>
    </div>
  </div>

} @else {
  <div class="check-ins-pop-up-loading">
    <lib-new-loading></lib-new-loading>
  </div>
}
